import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Categories = ({ data }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);

	return (
		<div className="products-home-section bg-none">
			<div className="container">
				<div className="d-flex justify-content-between align-items-center">
					<p className="title main-title mb-0">{t("categories")}</p>
					<Link to="/categories" className="shop-now text-primary">
						{t("Shop Now")}
					</Link>
				</div>
				<div className="products-swiper">
					{!!data?.length &&
						data?.map((item, index) => {
							return (
								<div
									key={index}
									onClick={() =>
										navigate(`/category/${item?.id}`, { state: item })
									}>
									<div
										data-aos="zoom-in-up"
										data-aos-easing="ease-in"
										data-aos-duration="800"
										className="category-card">
										<div className="category-card-image">
											<img
												src={item?.image}
												whileHover={{ scale: 1.1 }}
												whileTap={{ scale: 0.95 }}
												transition={{ type: "spring", stiffness: 200 }}
												alt="product"
												className="w-100"
											/>
										</div>
										<p className="title">
											{lang === "en" ? item?.name_en : item?.name_ar}
										</p>
									</div>
								</div>
							);
						})}
					{!data?.length && <h3 className="pb-5">{t(`There's no Product`)}</h3>}
				</div>
			</div>
		</div>
	);
};

export default Categories;
